export const GOOGLE_ANALYTICS_DOCUMENTATION =
  'https://docs.google.com/spreadsheets/d/13O1WknmSbzfkET6VD_o4-cH-x1mGUe-hQbHJyZHsRF0/edit?gid=0#gid=0';
